<!--
 * @Author: your name
 * @Date: 2020-11-22 22:39:27
 * @LastEditTime: 2020-11-22 23:09:01
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/order/refund/addlogistics/components/AddLogistics/index.vue
-->
<template>
  <div>
    <div
      v-for="(item, index) in logisticsList"
      :key="index"
      class="list text_left"
    >
      <div class="clearfix log_top" @click="delLogist(index)">
        <span class="top_title">{{ item.title }}</span>
        <img
          src="@/assets/mine/icon_delete@2x.png"
          alt=""
          class="right del_img"
        />
      </div>
      <div class="log_bottom">
        <p class="bot_det bot_mar">物流单号：{{ item.trackingNo }}</p>
        <p class="bot_det">物流公司：{{ item.logisticsName }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    logisticsList: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  computed: {},
  methods: {
    delLogist(index) {
      this.$emit("delLogist", index);
    }
  }
};
</script>

<style scoped>
.clearfix:after {
  visibility: hidden;
  display: block;
  font-size: 0;
  content: "";
  clear: both;
  height: 0;
}
.left {
  float: left;
}
.right {
  float: right;
}
.list {
  margin: 10px 10px 0;
  background: #fff;
  border-radius: 10px;
  padding: 9px 10px 13px;
}
.log_top {
  padding-bottom: 9px;
}
.top_title {
  font-size: 16px;
  font-weight: 500;
  color: rgba(34, 34, 34, 1);
  line-height: 22px;
}
.del_img {
  width: 18px;
  height: 18px;
}
.log_bottom {
  border-top: 1px solid #eee;
}
.bot_det {
  font-size: 14px;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 16px;
}
.bot_mar {
  margin: 15px 0 10px;
}
</style>
